import React from 'react';
import { useNavigate } from 'react-router-dom';
import { BelfiusButton } from './'; // Import your BelfiusButton component

interface BelfiusButtonWrapperProps {
    className?: string;
    title: string;
    navigateTo: string;
  }

const BelfiusButtonWrapper: React.FC<BelfiusButtonWrapperProps> = ({ className, title, navigateTo }) => {
    const navigate = useNavigate();
  
    const handleNavigate = () => {
      navigate(navigateTo);
    };
  
    return (
      <BelfiusButton
        className={className}
        onClick={handleNavigate}
        title={title}
      />
    );
  };
  
  export default BelfiusButtonWrapper;
  
